<div class="settings-content">

  <span class="mat-subtitle-1 no-select">{{ 'settings.phoneNumber' | translate }}</span>
  <mat-form-field appearance="outline">
    <input matInput type="tel" placeholder="+41791235678" [formControl]="phoneNumberFormControl">
    <mat-error *ngIf="phoneNumberFormControl.invalid">{{ 'settings.invalidPhoneNumber' | translate }}</mat-error>
  </mat-form-field>

  <span class="mat-subtitle-1 no-select">{{ 'settings.scannerSize' | translate }}</span>
  <mat-slider min="50" max="200" step="10"
              discrete [displayWith]="formatScannerSizeMultipleThumbLabel">
    <input matSliderThumb [formControl]="scannerSizeMultiplierFormControl">
  </mat-slider>
  <div>
    <mat-checkbox [formControl]="hideItemsBarFormControl">{{ 'settings.hideItemsBar' | translate }}</mat-checkbox>
  </div>
  <div>
    <mat-checkbox [formControl]="lowPowerScanningFormControl">{{ 'settings.lowPowerScanning' | translate }}</mat-checkbox>
  </div>

  <div class="debug-info no-select">
    X-UserName: {{ userName }}<br>
    X-FirstName: {{ firstName }}<br>
    X-LastName: {{ lastName }}<br>
    X-DeviceID: {{ deviceId }}<br>
  </div>

  <div class="debug-info no-select">
    {{ envName }} / V{{ appVersion }}
    <button *ngIf="!checkingForUpdate" class="link-button" (click)="checkForUpdates()">Check for Updates</button>
    <span *ngIf="checkingForUpdate">Checking...</span>
    <br>
    Inactivity Timeout (s): {{ scannerInactivityTimeoutSecs }}<br>
    Location state: {{ locationState }}<br>
    Location permission: {{ locationPermissionStatus }}
  </div>
</div>
<div class="settings-footer">
  <button class="footer-button" [disabled]="phoneNumberFormControl.invalid" mat-flat-button color="primary" (click)="save()">{{ 'save' | translate }}</button>
</div>
